export default __webpack_public_path__ + "static/media/genom.d0df3345.png";